<script>
import EmptyStateBlock from '@/components/general/empty-state-block.vue'
import VuetifyTextClass from '@/shared/constants/core/VuetifyTextClass'

export default {
  name: 'CandidateListEmptyState',
  components: { EmptyStateBlock },
  props: {
    showClearCta: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { VuetifyTextClass }
  },
}
</script>

<template>
  <EmptyStateBlock>
    <template v-slot:icon>
      <v-icon size="60" color="primary">mdi-information-outline</v-icon>
    </template>

    <template v-slot:title>
      <h3 :class="['my-2', VuetifyTextClass.h5]">
        {{ $t('candidateList.empty.title') }}
      </h3>
    </template>

    <template v-slot:description>
      <p :class="VuetifyTextClass.smallBody">
        {{ $t('candidateList.empty.body') }}
      </p>
    </template>

    <template v-slot:button>
      <v-btn
        v-if="showClearCta"
        data-testid="candidate-list-empty-clear"
        color="primary"
        depressed
        outlined
        class="mt-2"
        @click="$emit('clear')"
      >
        {{ $t('candidateList.empty.cta') }}
      </v-btn>
    </template>
  </EmptyStateBlock>
</template>
